export default {"src":"/_next/static/media/slide-interoperability-icon.c2a7867f.svg","height":78,"width":77};